/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
"use strict";
exports.DEFAULT_INTERPOLATION_CONFIG = {
    start: '{{',
    end: '}}'
};
//# sourceMappingURL=interpolation_config.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@angular/compiler/src/interpolation_config.js
 ** module id = 270
 ** module chunks = 2
 **/